import QRCode from 'qrcode-svg'

export const getQRCodeSVGString = (content: string) => {
  return new QRCode({ content, background: 'transparent' })
    .svg()
    .replace('<?xml version="1.0" standalone="yes"?>', '')
}
